module.exports = __webpack_public_path__ + "static/img/china.311dfb88.png";